import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9a3e4dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "operation" }
const _hoisted_3 = { class: "list ws_common_table" }

import { onMounted, ref, watch, onUnmounted } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import UserModal from './components/user-modal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { queryUserPage, queryUserDelete, queryUsersCurrentFull } from '@/api'
import Selecttenant from '@/components/select-tenant'
import moment from 'moment'
import { msgbox } from '@/utils'
import { useTenantStore } from '@/stores/tenant'
import OperationButtonList from '@/components/operation-button-list'


export default /*#__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {

const tenantStore = useTenantStore()

const getButtonList = (row: any) => {
  const { isSuperAdmin, topOrgId } = row
  return [
    {
      type: 'edit',
      text: '编辑',
      show: isSuperAdmin || topOrgId === tenantStore.topOrgId,
    },
    {
      type: 'delete',
      text: '删除',
      show: !isSuperAdmin && topOrgId === tenantStore.topOrgId,
    },
  ].filter((item: any) => {
    return item.show
  })
}

const toEdit = (data: any) => {
  userConf.value = {
    visible: true,
    data,
  }
}

const toShowRemoveTips = async (row: any) => {
  const { userId } = row
  msgbox({
    tip: '用户删除后，该用户的相关信息记录全部删除，无法找回',
    thenFn: () => removeUser(userId),
  })
}

const removeUser = async (userId: any) => {
  const res: any = await queryUserDelete({
    userIds: [userId],
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('删除成功')
    fetchList()
  }
}

const advancedRef = ref()

const columns: any = ref([
  {
    prop: 'username',
    label: '帐号',
  },
  {
    prop: 'nickname',
    label: '姓名',
  },
  {
    prop: 'topOrgName',
    label: '所属组织',
  },
  {
    prop: 'roleName',
    label: '角色',
  },
  {
    prop: 'createTime',
    label: '创建时间',
    formatter: (row: any) => {
      return moment(row.createTime).format('YYYY-MM-DD HH:mm')
    },
  },
])

const userConf = ref({
  visible: false,
  data: {},
})

const tableData: any = ref([])
const formInline = ref({
  orgId: undefined,
  nickname: '',
  username: '',
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = (pageSize: number) => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = (pageSize: number) => {
  fetchList()
}

const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await queryUserPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(async () => {
  await tenantStore.queryTopOrg()

  fetchList()
})

const isSuperAdmin = ref(false)
const queryAuth = async () => {
  const res: any = await queryUsersCurrentFull()
  isSuperAdmin.value = res?.data?.sysUserData?.isSuperAdmin || false
}
queryAuth()

const showModal = (data = {}) => {
  userConf.value = {
    visible: true,
    data,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "租户",
          prop: "orgId"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Selecttenant), {
              modelValue: formInline.value.orgId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.orgId) = $event)),
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "帐号",
          prop: "username"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.username) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "姓名",
          prop: "nickname"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.nickname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.nickname) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      (isSuperAdmin.value)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: showModal,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建用户")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        stripe: ""
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: item.prop,
              prop: item.prop,
              label: item.label,
              formatter: item.formatter,
              "show-overflow-tooltip": ""
            }, null, 8, ["prop", "label", "formatter"]))
          }), 128)),
          (isSuperAdmin.value)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "logType",
                width: 180,
                label: "操作"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(OperationButtonList), {
                    scope: scope.row,
                    buttonList: getButtonList(scope.row),
                    onOnEdit: toEdit,
                    onOnDelete: toShowRemoveTips
                  }, null, 8, ["scope", "buttonList"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(UserModal, {
      visible: userConf.value.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((userConf.value.visible) = $event)),
      data: userConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ]))
}
}

})